import { formatPercentage as formatPercentageDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatNumberProps = {
    perc: number;
    decimals: number;
}

export const formatPercentage = ({ perc, decimals }: FormatNumberProps): string =>
    formatPercentageDiagram(perc, decimals);
